import React, { useEffect, useState } from "react";
import { TimePicker, Row } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const SelectCustomDate = ({
  tipo,
  idCampo,
  nombreCampo,
  elValue,
  elPlaceholder,
  required,
  tipoError,
  error,
  onChange,
}) => {
  // console.log("el value", elValue)
  const [value, setValue] = useState();

  // Mostrar "*" si es requerido
  const esRequired = required ? "*" : "";

  // Cuando cambia el valor recibido por props
  useEffect(() => {
    if (elValue) {
      const parsedTime = dayjs(elValue, "HH:mm", true);
      if (parsedTime.isValid()) {
        setValue(parsedTime);
      } else {
        setValue(null);
      }
    } else {
      setValue(null);
    }
  }, [elValue]);


  // Cuando se elige una nueva hora
  const onChangeDate = (time) => {
    setValue(time);
    const formatted = time ? time.format("HH:mm") : null;

    // Simulamos evento para el padre
    onChange({ target: { value: formatted, id: idCampo } });
  };

  return (
    <Row justify={"start"}>
      <label htmlFor={idCampo}>
        <p className="nombre-campo">
          {nombreCampo} {esRequired}
        </p>
      </label>

      <TimePicker
        className="input-component"
        id={idCampo}
        placeholder={elPlaceholder}
        onChange={onChangeDate}
        value={value}
        format="HH:mm"
        defaultOpenValue={dayjs("00:00", "HH:mm")}
        status={tipoError}
      />

      <span className="spanErrores" style={{ color: "red" }}>
        <b>{error}</b>
      </span>
    </Row>
  );
};

